import ProjectTemplate from '../../components/common/ProjectTemplate';
import ComponentListContainer from '../../components/conveyor-component/ComponentListContainer';

const ComponentListPage = () => {
    return (
        <ProjectTemplate>
            <ComponentListContainer />
        </ProjectTemplate>
    );
};

export default ComponentListPage;
